import { ICurrentUser, IRequestRecord, IRequestUser } from 'types/requests.interface'

export const REQ_ANNUAL = 1
export const REQ_SICK = 2
export const REQ_UNPAID = 3
export const REQ_DAYOFF = 4
export const REQ_SHIFT = 5
export const REQ_OVERTIME = 6

export const ST_PENDING = 1
export const ST_APPROVED = 2
export const ST_REJECTED = 3
export const ST_CANCELLED = 4

export const requestTypeOptions = [
  { value: REQ_ANNUAL, label: 'Annual Leave' },
  { value: REQ_SICK, label: 'Sick Leave' },
  { value: REQ_UNPAID, label: 'Unpaid Leave' },
  { value: REQ_DAYOFF, label: 'Day Off' },
  { value: REQ_SHIFT, label: 'Shift Change' },
  { value: REQ_OVERTIME, label: 'Overtime' },
]

export const statusOptions = [
  { value: ST_PENDING, label: 'Pending' },
  { value: ST_APPROVED, label: 'Approved' },
  { value: ST_REJECTED, label: 'Rejected' },
  { value: ST_CANCELLED, label: 'Cancelled' },
]

export const RANGE_TYPES = [REQ_ANNUAL, REQ_SICK, REQ_UNPAID]

export const typeLabel = (n: number) => requestTypeOptions.find((o) => o.value === n)?.label || 'Request'
export const statusLabel = (n: number) => statusOptions.find((o) => o.value === n)?.label || 'Unknown'

export const statusPill = (n: number): 'warning' | 'success' | 'danger' | 'neutral' => {
  if (n === ST_PENDING) return 'warning'
  if (n === ST_APPROVED) return 'success'
  if (n === ST_REJECTED) return 'danger'
  return 'neutral'
}

export const typePill = (n: number): 'info' | 'success' | 'warning' | 'neutral' => {
  if (n === REQ_SHIFT) return 'info'
  if (n === REQ_OVERTIME) return 'warning'
  if (n === REQ_DAYOFF) return 'neutral'
  return 'success'
}

export const userName = (u: IRequestUser | ICurrentUser | null) => {
  if (!u) return '—'
  const name = [u.firstName, u.lastName].filter(Boolean).join(' ')
  return name || '—'
}

export const leaveDays = (from: string, to: string) => {
  const a = new Date(from)
  const b = new Date(to)
  const start = new Date(a.getFullYear(), a.getMonth(), a.getDate()).getTime()
  const end = new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime()
  const days = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1
  return days < 1 ? 1 : days
}

export const durationLabel = (req: IRequestRecord) => {
  if (req.type === REQ_SHIFT) return 'Swap'
  if (req.type === REQ_OVERTIME) return `+${req.overtimeHours || 0}h`
  const d = leaveDays(req.from, req.to)
  return `${d} ${d === 1 ? 'day' : 'days'}`
}
